// import { createBrowserRouter } from 'react-router-dom'
// import App from '../App'
// import Home from '../pages/Home'
// import Login from '../pages/Login'
// import ForgotPassowrd from '../pages/ForgotPassowrd'
// import SignUp from '../pages/SignUp'
// import AdminPanel from '../pages/AdminPanel'
// import AllUsers from '../pages/AllUsers'
// import AllProducts from '../pages/AllProducts'
// import CategoryProduct from '../pages/CategoryProduct'
// import ProductDetails from '../pages/ProductDetails'
// import Cart from '../pages/Cart'
// import SearchProduct from '../pages/SearchProduct'
// import Contact from '../pages/Contact'
// import AboutUs from '../pages/AboutUs'
// import CategoryPage from '../pages/CategoryPage'
// import Profile from '../pages/Profile'


// const router = createBrowserRouter([
//     {
//         path : "/",
//         element : <App/>,
//         children : [
//             {
//                 path : "",
//                 element : <Home/>
//             },
//             {
//                 path :"contact",
//                 element:<Contact/>
//             },
//             {
//                 path :"aboutus",
//                 element:<AboutUs/>
//             },
//             {
//                 path :"/category/:categoryName",
//                 element : <CategoryPage/>

//             },

//             {
//                 path : "login",
//                 element : <Login/>
//             },
//             {
//                 path : "forgot-password",
//                 element : <ForgotPassowrd/>
//             },
//             {
//                 path : "sign-up",
//                 element : <SignUp/>
//             },
//             {
//                 path : "product-category",
//                 element : <CategoryProduct/>
//             },
//             {
//                 path : "product/:id",
//                 element : <ProductDetails/>
//             },
//             {
//                 path : 'cart',
//                 element : <Cart/>
//             },
//             {
//                 path : "search",
//                 element : <SearchProduct/>
//             },
//             {
//     path: "profile",
//     element: <Profile/>
// },
//             {
//                 path : "admin-panel",
//                 element : <AdminPanel/>,
//                 children : [
//                     {
//                         path : "all-users",
//                         element : <AllUsers/>
//                     },
//                     {
//                         path : "all-products",
//                         element : <AllProducts/>
//                     }
//                 ]
//             },
//         ]
//     }
// ])


// export default router


import { createBrowserRouter } from 'react-router-dom'
import App from '../App'
import Home from '../pages/Home'
import Login from '../pages/Login'
import ForgotPassowrd from '../pages/ForgotPassowrd'
import SignUp from '../pages/SignUp'
import AdminPanel from '../pages/AdminPanel'
import AllUsers from '../pages/AllUsers'
import AllProducts from '../pages/AllProducts'
import CategoryProduct from '../pages/CategoryProduct'
import ProductDetails from '../pages/ProductDetails'
import Cart from '../pages/Cart'
import SearchProduct from '../pages/SearchProduct'
import Contact from '../pages/Contact'
import AboutUs from '../pages/AboutUs'
import CategoryPage from '../pages/CategoryPage'
import Profile from '../pages/Profile'
import Checkout from "../pages/Checkout"
import Wishlist from "../pages/Wishlist"
import AllOrders from '../pages/AllOrders'

const router = createBrowserRouter([
    {
        path: "/",
        element: <App />,
        children: [
            {
                index: true,   // ✅ FIXED
                element: <Home />
            },
            {
                path: "contact",
                element: <Contact />
            },
            {
                path: "aboutus",
                element: <AboutUs />
            },
            {
                        path: "wishlist",
                         element: <Wishlist />
                                   },
            {
                path: "category/:categoryName",   // ✅ FIXED (removed /)
                element: <CategoryPage />
            },
            {
                path: "login",
                element: <Login />
            },
            {
                path: "forgot-password",
                element: <ForgotPassowrd />
            },
            {
                path: "sign-up",
                element: <SignUp />
            },
            {
                path: "product-category",
                element: <CategoryProduct />
            },
            {
                path: "product/:id",
                element: <ProductDetails />
            },
            {
                path: 'cart',
                element: <Cart />
            },
            {
                path: "search",
                element: <SearchProduct />
            },
            {
                path: "profile",
                element: <Profile />
            },
            {
                path: "checkout",   // ✅ already correct
                element: <Checkout />
            },
            {
                path: "admin-panel",
                element: <AdminPanel />,
                children: [
                    {
                        path: "all-users",
                        element: <AllUsers />
                    },
                    {
                        path: "all-products",
                        element: <AllProducts />
                    },
                    {
                        path: "all-orders",
                        element:<AllOrders/>
                    }
                                      
                ]
            },
        ]
    }
])

export default router